import StringsPT from './pt-br/Strings.json'
import StringsES from './es/Strings.json'
import StringsEN from './en/Strings.json'
import Paises from './paises.json'
import Cidades from './cidades.json'
import BezerrosInstrucoesPT from './pt-br/bezerros_instrucoes.json'
import BezerrosInstrucoesEN from './en/bezerros_instrucoes.json'
import BezerrosInstrucoesES from './es/bezerros_instrucoes.json'

const strings = [
  StringsPT,
  StringsEN,
  StringsES
]

export const paises = Paises
export const estados = Cidades.estados
export const BezerrosInstrucoes = [BezerrosInstrucoesPT, BezerrosInstrucoesEN, BezerrosInstrucoesES]

export const getString = (key, idioma = null) => {
  if (!idioma) idioma = parseInt(localStorage.getItem('idioma') || 0);
  if (strings && strings[idioma] && strings[idioma][key]) {
      return strings[idioma][key]
  }
  return null
}

export default strings
